import { createSelector } from 'reselect'

export const userGroupsSelector = ({ userGroups }) => userGroups.list.userGroups
const userGroupsStatusSelector = ({ userGroups }) => userGroups.list.status
export const userGroupsParamsSelector = ({ userGroups }) => userGroups.list.params

export const isUserGroupsLoadingSelector = createSelector(
  userGroupsStatusSelector,
  (status) => status === 'loading'
)

export const isUserGroupsFailedSelector = createSelector(
  userGroupsStatusSelector,
  (status) => status === 'failed'
)

export const userGroupsfilterTermSelector = createSelector(
  userGroupsParamsSelector,
  (params) => params.filter_term
)

export const userGroupsPageSelector = createSelector(
  userGroupsParamsSelector,
  (params) => params.page
)

export const userGroupsSortOrderSelector = createSelector(
  userGroupsParamsSelector,
  (params) => params.sort_order
)

export const userGroupsSortFieldSelector = createSelector(
  userGroupsParamsSelector,
  (params) => params.sort_field
)
